import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import {
  LoadSecondary,
  TransportOrderPrimary,
} from '../../../../store/state/monitoring/transport/models/transport-list.model';
import { UNKNOWN } from '../../../../common/constants/template.constant';
import { TransportMode } from '../../../../common/constants/transport-mode';
import { ShipmentFilterType } from '../../../../store/models';
import { MonitoringPageType } from '../../../../store/state/monitoring/constants';
import { DeviationType, DateType } from '../../../../store';

@Component({
  selector: 'ui-transport-order-card',
  templateUrl: './transport-order-card.component.html',
  styleUrls: ['./transport-order-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransportOrderCardComponent {
  @Input() set transportOrderItem(value: TransportOrderPrimary) {
    this.transportOrder = value;

    this.hasLabel = value.loads.some(
      ({ deviation: { deviationType }, isCancelled }: LoadSecondary) =>
        deviationType === ShipmentFilterType.Early || deviationType === ShipmentFilterType.Delay || isCancelled,
    );

    this.hasSpeedUpInfo = value.loads.some(({ speedUpInformation }: LoadSecondary) => Boolean(speedUpInformation));
  }
  @Input() monitoringPageType: MonitoringPageType;

  unknown = UNKNOWN;
  transportMode = TransportMode;
  deviationType = DeviationType;
  dateType = DateType;
  transportOrder: TransportOrderPrimary;
  hasLabel: boolean;
  hasSpeedUpInfo: boolean;
}
